import { TFunction } from "i18next";
import { z } from "zod";
import { nullableNumber } from "../../../utils";


export const getCreateCaptureFormSchema = (t: TFunction) => {
  const numberField = nullableNumber(t("generic.errors.invalid-number"));
  return z.object({
    managementUnitId: z.number().positive().nullable().optional(),
    
    name: z
      .string()
      .max(255)
      .min(1, { message: t("captures.capture.general.identification.errors.name-required") }),
    
    aquaEpsDesignation: z.string().max(255).nullable().optional(),
    entityDesignation: z.string().max(255).nullable().optional(),
    licensingDesignation: z.string().max(255).nullable().optional(),
      licensingDesignationSystem: z
        .enum(["SNIRH", "TUA"], {
          errorMap: () => ({
            message: t("captures.capture.general.identification.errors.licensing-system-invalid"),
          }),
        })
        .nullable()
        .optional(),

    coordinates: z.discriminatedUnion("crs", [
      z.object({
        crs: z.literal("ETRS89"),
        xETRS: z    
          .number({
            required_error: t("captures.capture.general.location-details.errors.xETRS-required"),
            invalid_type_error: t("captures.capture.general.location-details.errors.xETRS-invalid"),
          }),

        yETRS: z
          .number({
            required_error: t("captures.capture.general.location-details.errors.yETRS-required"),
            invalid_type_error: t("captures.capture.general.location-details.errors.yETRS-invalid"),
          }),
        zETRS: numberField.optional(),
      }),
      z.object({
        crs: z.literal("WGS84"),
        longitude: z
          .number({
            required_error: t("captures.capture.general.location-details.errors.longitude-required"),
            invalid_type_error: t("captures.capture.general.location-details.errors.longitude-invalid"),
          }),
        latitude: z
          .number({
            required_error: t("captures.capture.general.location-details.errors.latitude-required"),
            invalid_type_error: t("captures.capture.general.location-details.errors.latitude-invalid"),
          }),
        elevation: numberField.optional(),
      }),
    ]),
  });
};

export type CreateCaptureForm = z.infer<ReturnType<typeof getCreateCaptureFormSchema>>;